import React from 'react';
import { Button, Modal } from 'gatorcomponents';
import * as Styles from './ModalPlanHireSuccess.styles';
import useLocale from '@/hooks/useLocale';
import TopImage from '../../media/modal-plan-hire-success/hired-banner.png';
import TopImageMobile from '../../media/modal-plan-hire-success/hired-banner-mobile.png';
import { useResize } from '@/hooks/useResize';
import ConfettiAnimation from '../../media/confetti.gif';

const ModalPlanHireSuccess = ({ closeModal }) => {
  const { studio: studioLocale } = useLocale();
  const { modalPlanHireSuccess: modalPlanHireSuccessLocale } = studioLocale;
  const windowRect = useResize();
  const { width } = windowRect;
  const mobile = width < 600;

  const handleCloseModal = () => {
    closeModal && closeModal();
  };

  return (
    <Modal
      maxHeight={547}
      maxWidth={960}
      noContentPadding
      onClose={handleCloseModal}
      noHeader
      testId="modal-plan-hire-success"
    >
      <Styles.Container>
        <Styles.BannerTopImage src={mobile ? TopImageMobile : TopImage} alt={modalPlanHireSuccessLocale.successAlt} />

        <Styles.ModalTitle>
          {modalPlanHireSuccessLocale.title}
        </Styles.ModalTitle>
        <Styles.ModalDescription>
          {modalPlanHireSuccessLocale.description}
        </Styles.ModalDescription>

        <Styles.ButtonContainer>
          <Button
            label={modalPlanHireSuccessLocale.buttonLabel}
            onClick={handleCloseModal}
            version="v2"
            size="large"
            width="full"
          />
        </Styles.ButtonContainer>
        <Styles.SuccessAnimation src={ConfettiAnimation} alt={modalPlanHireSuccessLocale.animationAlt} />
      </Styles.Container>
    </Modal>
  );
};

export default ModalPlanHireSuccess;
